import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonConfig } from '@libraries/design-system';
import { isMobile } from '@libraries/ui-state';
import { Store, select } from '@ngrx/store';

@Component({
  selector: 'page-footer',
  templateUrl: './page-footer.component.html',
  styleUrls: ['./page-footer.component.scss'],
  standalone: false,
})
export class PageFooterComponent {
  isMobile$ = this.store.pipe(select(isMobile));
  @Input() primary: ButtonConfig;
  @Input() secondary: ButtonConfig;
  @Input() primLoading: boolean;
  @Input() primDisabled: boolean;
  @Input() secLoading: boolean;
  @Input() secDisabled: boolean;
  @Input() layout: 'apart' | 'adjacent';

  // MOBILE ONLY
  @Input() hidden = false;
  @Input() valid = false;
  @Input() primCenteredIfNoSecondary = false;

  @Output() primaryClicked = new EventEmitter();
  @Output() secondaryClicked = new EventEmitter();

  constructor(private store: Store) {}

  primaryClick() {
    this.primaryClicked.emit();
  }

  secondaryClick() {
    this.secondaryClicked.emit();
  }
}
